import React from "react";
import "~/common/polyfill/index.js";
import App from "@al/next/app";
import { withApp, customSentryReportIfEnabled } from "@al/next/al-ex";
import { WebpImage, LazyImage, Toast, ConfigProvider } from "@al/akui-mobile";
import { setToast } from "@al/eu-security-verify-foundation";
// import performanceCollection from "@al/performance-collect";

// import { startBeforePopStateListener } from "~/components/hooks/useRouteChange";
// import SelectCountry from "~/components/ui/SelectCountry";
// import AcceptCookie from "~/components/ui/AcceptCookie";
import createGlobalConfig from "~/global/index";
import InitProgress from "~/components/ui/InitProgress";
// import { initDeviceSDK } from "~/common/device-sdk";
import getAntdLocale from "~/common/utils/getAntdLocale";
import { initTracker } from "~/common/tracker";
import eu_img_preview from "~/common/imgs/img_pre_eu.png";

if (process.browser) {
  initTracker();
}

/**
 * 2种方式定义_app
 * 1. 拓展，通过import App from '@al/next/app'继承
 * 2. 自定义Component
 * **/

class MyApp extends App {
  constructor(props) {
    super(props);
    LazyImage.previewImageUrl = eu_img_preview;

    // webp 探测
    WebpImage.initWebpOptions({ req: props.ctx.req });

    // 初始化用户信息
    // this.initUserInfo();

    // 初始化设备SDK
    // this.initDeviceSDK();

    // 路由重定向
    // this.handleRouterRedirect();

    // 监听路由切换
    // if (process.browser) {
    //   props.ctx.router.events.on("routeChangeStart", () => {
    //     performanceCollection.writeFrameData();
    //   });
    //   props.ctx.router.events.on("routeChangeComplete", () => {
    //     window.scroll({ top: 0 });
    //     this.handleRouterIntercept();
    //   });
    //   startBeforePopStateListener();
    // }
  }

  // handelUpload = () => {
  //   const ctx = this.props.ctx;
  //   const userDetail = ctx.store.getState().sign?.userDetail;
  //   DeviceSDK.upload({
  //     extra: {
  //       scenario_number: ReportDeviceScenes.OpenApp,
  //       user_id: userDetail?.uid || 0,
  //     },
  //   });
  // };

  // handleRouterRedirect = () => {
  //   if (this.props.ctx.asPath === "/") {
  //     const redirectRoute = `/mobile/main/home`;
  //     // 重定向根路由到首页
  //     if (process.server) {
  //       this.props.ctx.res?.redirect(redirectRoute);
  //     } else {
  //       location.replace(redirectRoute);
  //     }
  //     return;
  //   } else {
  //     const isIntercept = this.handleRouterIntercept();
  //     if (!isIntercept) {
  //       this.handleRouterCheck();
  //     }
  //   }
  // };

  // handleRouterCheck = () => {
  //   // 只检查一次
  //   if (this.isCheck) {
  //     return;
  //   }
  //   this.isCheck = true;
  //   const { query } = this.props.ctx;

  //   // 去除 query 上的 countryCode
  //   if (query.countryCode) {
  //     const router = this.props.ctx.router;
  //     const query = {
  //       ...router.query,
  //       countryCode: undefined,
  //     };
  //     delete query.countryCode;
  //     const queryLength = Object.keys(query).length;
  //     const pathname = `${router.asPath}`.split("?")[0];
  //     if (process.server) {
  //       this.props.ctx.res?.redirect(
  //         `${router.basePath}${pathname}${queryLength > 0 ? `?${qs.stringify(query)}` : ""}`
  //       );
  //     } else {
  //       router.replace(
  //         {
  //           pathname,
  //           query,
  //         },
  //         undefined,
  //         { shallow: true }
  //       );
  //     }
  //   }
  // };

  // handleRouterIntercept = () => {
  //   const ctx = this.props.ctx;
  //   const isSign = ctx.store.getState().sign.isSign;
  //   const pathname = `${ctx.router.asPath}`.split("?")[0];
  //   // 错误页面的时候 isSign 一定为 false
  //   if (!isSign && pathname) {
  //     unauthorizedToLogin(ctx);
  //   }
  //   return ctx.locale.countryCode && !NO_LOGIN_ROUTER.includes(pathname);
  // };

  // initUserInfo = () => {
  //   if (!this.props.ctx.err && !this.props.pageProps.statusCode) {
  //     // 渲染错误页时不处理
  //     const { ctx, globalUserInfo } = this.props.pageProps;
  //     if (!ctx.lifecycleStatus.isExport) {
  //       // 特别注意，prerender 时的中间态，是否登录不确定。需延迟至 csr 请求接口确认
  //       if (globalUserInfo && globalUserInfo.value && globalUserInfo.value.success) {
  //         ctx.store.dispatch(ctx.actions.sign.updateSignState(globalUserInfo.value.data));
  //       } else {
  //         ctx.store.dispatch(ctx.actions.sign.clearSignState());
  //       }
  //     }
  //   }
  // };

  // initDeviceSDK = () => {
  //   if (process.browser) {
  //     initDeviceSDK(this.props.ctx);
  //     // 安全组件Toast设置
  //     setToast(Toast);
  //   }
  // };

  componentDidMount() {
    // 页面域名错误时，sentry上报
    if (this.pageHostError) {
      customSentryReportIfEnabled(new Error("app访问页面域名有误"), "root_app", (scope) => {
        scope.setExtras({
          link: location.href,
          systemProcess: JSON.stringify(this.props.ctx.store.getState().container.static.systemProcess),
        });
      });
    }

    // 上报启动app
    // this.handelUpload();

    // 安全组件报错
    setToast(Toast);
  }

  render() {
    const { Component, pageProps } = this.props;
    return (
      <ConfigProvider locale={getAntdLocale(this.props.ctx, this.props.t)}>
        <InitProgress />
        <Component {...pageProps} />
        {/* 接受 Cookie */}
        {/* <AcceptCookie /> */}
        {/* 兜底国家选择 */}
        {/* <SelectCountry /> */}
      </ConfigProvider>
    );
  }
}

export default withApp(MyApp, createGlobalConfig);
